import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { CHART_OPTIONS, BAR_OPTIONS } from '../constants/dashboardConstants';

export const ChartsSection = ({ revenueChartData, monthlyLeadsData }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
      {/* Monthly Revenue Line Chart */}
      <div className="card p-5 lg:col-span-2">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="text-lg font-semibold text-slate-800 font-sans tracking-tight">Monthly Revenue</h3>
            <p className="text-xs text-slate-400 mt-0.5">Revenue trend over time</p>
          </div>
        </div>
        <div style={{ height: 220 }}>
          <Line data={revenueChartData} options={CHART_OPTIONS} />
        </div>
      </div>

      {/* Monthly Leads Bar Chart */}
      <div className="card p-5">
        <div className="mb-5">
          <h3 className="text-lg font-semibold text-slate-800 font-sans tracking-tight">Monthly Leads</h3>
          <p className="text-xs text-slate-400 mt-0.5">Leads generated per month</p>
        </div>
        <div style={{ height: 200 }}>
          <Bar data={monthlyLeadsData} options={BAR_OPTIONS} />
        </div>
      </div>
    </div>
  );
};
